import styled from "styled-components";

export const NestedList = styled.div`
    .point-list > li {
        list-style-type: disc;
        margin: 0;
        font-weight: ${(props) => props.theme.fontWeightBase};
    }

    ol {
        list-style-type: none;
        counter-reset: item;
        margin: 0;
        padding: 0;
    }

    ol > li {
        display: table;
        counter-increment: item;
        margin-bottom: 0.8em;
        padding-top: 1rem;
        font-weight: ${(props) => props.theme.fontWeightBold};

        p {
            font-weight: ${(props) => props.theme.fontWeightBase};
            margin: 0;
        }
    }

    ol > li::before {
        content: counters(item, ".") ". ";
        display: table-cell;
        padding-right: 0.3em;
    }

    li > p {
        padding-top: 1rem;
        font-weight: ${(props) => props.theme.fontWeightBase};
    }

    li ol > li {
        margin: 0;
        font-weight: ${(props) => props.theme.fontWeightBase};
    }

    li ol > li::before {
        content: counters(item, ".") " ";
    }
`;
